import * as React from 'react';
import { StyledMenuItemWrapper } from './styles.js';
import MenuItem from './MenuItem.js';
import Separator, { SeparatorType } from '@doordash/component-separator';
import { Inset, InsetSize } from '@doordash/design-language';

var MenuItemWrapper = function MenuItemWrapper(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(StyledMenuItemWrapper, {
    item: item
  }, item.customContent ? item.customContent : /*#__PURE__*/React.createElement(MenuItem, item), item.hasSeparator && /*#__PURE__*/React.createElement(Inset, {
    size: InsetSize.Small,
    isSquished: true
  }, /*#__PURE__*/React.createElement(Separator, {
    type: SeparatorType.FullBorder
  })));
};

export { MenuItemWrapper as default };
